import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExcel = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <rect width={32} height={32} fill="#1BCF63" rx={5} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M8.472 7h4.365l3.232 6.75L19.772 7h4.03l-5.352 8.97L24 25h-4.157l-3.774-7.02L12.294 25H8l5.824-9.03z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgExcel;
